<template>
   <app-parser_wrapper  :init="init">    </app-parser_wrapper>
</template>

<script>
 export default {

     data () {
       return {
   init: {
     menu:{
       items: [
         {
           title:"Группы",
           objName: 'groups',
           dataType:"pages",
           form: [
             {
               type:'info',
               vModel: {contentType:'groups',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообществ",
                 contentType: 'groups',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'groups',
               dataType: 'memory',
             },
           {
             type:'textarea',
             name: 'Список сообществ',
             vModel: {name:'itemsList',value:''},
             vkapi: false,
             dataType: 'list'
           },

           {
             type: 'input',
             name: 'Подписчиков с сообщества',
             vModel: {name:'fl_count',value:'1000'},
             vkapi: false,
             dataType: 'FormParams'
           },
           ],

       },

         {
           title:"Страницы",
           objName: 'pages',
           dataType:"pages",
           form: [
             {
               type:'info',
               vModel: {contentType:'pages',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список страниц',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список страниц",
                 contentType: 'pages',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.pages,
               label: 'Использовать запомненные страницы: '+ this.$store.state.memory.pages ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'pages',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список страниц',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },



             {
               type:'input',
               name: ' Друзей со страницы',
               vModel: {name:'fr_count',value:'1000'},
               vkapi: true,
               dataType: 'FormParams'

             },
             {
               type: 'input',
               name: ' Подписчиков со страницы',
               vModel: {name:'fl_count',value:'1000'},
               vkapi: false,
               dataType: 'FormParams'
             },
           ]
         },

         {
           title:"Лайки",
           objName: 'likes',
           dataType:"pages",
           form:  [
             {
               type:'info',
               vModel: {contentType:'videos',value:''},
               vkapi: false,
             },
             {
               type:'select',
               name: 'Тип объкта',
               options: [{text:'Посты',value:'post'},{text:'Комментария к постам',value:'comment'},{text:'Фото',value:'photo'},{text:'Аудиозаписи',value:'audio'},{text:'Видеозаписи',value:'video'},{text:'Заметки',value:'note'},{text:'Товары',value:'market'}  ],
               vModel: {name:'objType',value:'video'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type:'procBinding',
               name: 'Список оьектов',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообществ",
                 contentType: 'videos',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.videos,
               label: "Использовать запомненные " + this.$store.state.memory.videos    ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'videos',
               dataType: 'memory',
             },

             {
               type:'textarea',
               name: 'Список объектов',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },
             {
               type: 'input',
               name: 'Колличество с объкта',
               vModel: {name:'count',value:'1000'},
               vkapi: false,
               dataType: 'FormParams'
             },
           ]

         },
         {
           title:"Комментария",
           objName: 'comments',
           dataType:"pages",

           form:  [
             {
               type:'info',
               vModel: {contentType:'videos',value:''},
               vkapi: false,
             },
             {
               type:'select',
               name: 'Тип объкта',
               options: [{text:'Посты',value:'posts'},{text:'Видео',value:'videos'},{text:'Фото',value:'photos'} ],
               vModel: {name:'objType',value:'videos'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type:'procBinding',
               name: 'Список оьектов',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список сообществ",
                 contentType: 'videos',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.videos,
               label: "Использовать запомненные " + this.$store.state.memory.videos    ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'videos',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список объектов',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },
             {
               type:'select',
               name: 'Порядок сортировки',
               options: [{text:'Хронологический',value:'asc'},{text:'Антихронологический',value:'desc'} ],
               vModel: {name:'sort',value:'asc'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type: 'input',
               name: 'Колличество с объкта',
               vModel: {name:'count',value:'1000'},
               vkapi: false,
               dataType: 'FormParams'
             },

           ]

         },
         {
             title:"Обсуждения",
             objName: "topics",
             dataType:"pages",
             form: [
               {
                 type:'topics',
                 vModel: {contentType:'groups',value:''},
                 vkapi: false,
               },
               {
                 type:'procBinding',
                 name: 'Список обсуждений',
                 vModel: {
                   procResults: {
                     items: [],
                     selected: [],
                     active: true,
                   },
                   procResultsLabel: "Использовать результаты других процессов",
                   procUpdates: {
                     items: [],
                     selected: [],
                     active:false,
                   },
                   procUpdatesLabel: "Обновления процессов как список обсуждений",
                   contentType: 'topics',

                 },
                 vkapi: false,
                 dataType: 'procBinding',
               },
               {
                 type:'useMemoryItems',
                 memoryCounter: this.$store.state.memory.topics,
                 label: 'Использовать запомненные обсуждения: '+ this.$store.state.memory.topics ,
                 vModel: {name:'isSelect',value:0},
                 vkapi: false,
                 memoryType: 'topics',
                 dataType: 'memory',
               },
               {
                 type:'textarea',
                 name: 'Список обсуждений',
                 vModel: {name:'itemsList',value:''},
                 vkapi: false,
                 dataType: 'list'
               },

               {
                 type:'select',
                 name: 'Фильтр',
                 options: [{text:'Хронологический',value:'asc'},{text:'Антихронологический',value:'desc'} ],
                 vModel: {name:'sort',value:''},
                 vkapi: true
               },
               {
                 type: 'input',
                 name: 'Максимум с обсуждения',
                 vModel: {name:'count',value:'50'},
                 vkapi: false
               },
             ],

         },
         {
           title:"Авторы постов",
           objName: 'postAuthor',
           dataType:"pages",
           form: [
             {
               type:'info',
               vModel: {contentType:'pages',value:''},
               vkapi: false,
             },
             {
               type:'select',
               name: 'Тип объкта',
               options: [{text:'Сообщества',value:'groups'},{text:'Страницы',value:'pages'} ],
               vModel: {name:'objType',value:'groups'},
               vkapi: false,
               dataType: 'FormParams'
             },
             {
               type:'procBinding',
               name: 'Список Сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список Сообществ",
                 contentType: 'groups',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'groups',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список Сообществ',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },
             {
               type: 'input',
               name: 'Максимум с одного ресурса',
               vModel: {name:'count',value:'50'},
               vkapi: false
             },

           ]
         },
         {
           title:"Контакты сообществ",
           objName: 'publicContacts',
           dataType:"pages",
           form: [
             {
               type:'info',
               vModel: {contentType:'pages',value:''},
               vkapi: false,
             },
             {
               type:'procBinding',
               name: 'Список Сообществ',
               vModel: {
                 procResults: {
                   items: [],
                   selected: [],
                   active: true,
                 },
                 procResultsLabel: "Использовать результаты других процессов",
                 procUpdates: {
                   items: [],
                   selected: [],
                   active: false,
                 },
                 procUpdatesLabel: "Обновления процессов как список Сообществ",
                 contentType: 'groups',

               },
               vkapi: false,
               dataType: 'procBinding',
             },
             {
               type:'useMemoryItems',
               memoryCounter: this.$store.state.memory.groups,
               label: 'Использовать запомненные сообщества: '+ this.$store.state.memory.groups ,
               vModel: {name:'isSelect',value:0},
               vkapi: false,
               memoryType: 'groups',
               dataType: 'memory',
             },
             {
               type:'textarea',
               name: 'Список Сообществ',
               vModel: {name:'itemsList',value:''},
               vkapi: false,
               dataType: 'list'
             },


           ]
         },


       ],

     },
    title:{
      first: 'Страниц найдено:'
    },

    searchLoop:{
      active:false,
      placeholder:'Введите имя через запятую'
    },

    beforeSearch:{
      title: 'Тут будет отображен результат парсера страниц',
      activator: true,
      activatorName: 'Начать парсинг'
    },


    network:{
      processName: 'pages_pars',
      dataType: 'pages',
      actionsFile:  'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/searcher/pages_pars.php'
    },

    contentMenegment: {
      marginTop: '0px',
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
      }
     },
     progressСircular: false,
   }


       }
     },


   }
</script>


<style>

</style>
